import { createClient } from "@supabase/supabase-js";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ZipmapRepository from "../../repository/ZipmapRepository";
import DashboardSideNav from "./DashboardSideNav";
import DashboardPageMain from "./DashboardPageMain";
import DashboardAddMapModal from "./DashboardAddMapModal";
import UserRepository from "../../repository/UserRepository";
import PendingInvitations from "../../shared/components/pendinginvitations/PendingInvitations";
import { Helmet } from "react-helmet";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function DashboardPage({ analytics, onSignOutClick }) {

    const navigate = useNavigate()
    const [isLoadingMaps, setIsLoadingMaps] = useState(true)
    const [isSavingInvitation, setIsSavingInvitation] = useState(false)
    const [userMaps, setUserMaps] = useState([])
    const [selectedMap, setSelectedMap] = useState(null)
    const [isAddMapModalOpen, setIsAddMapModalOpen] = useState(false)
    const [userInvitations, setUserInvitations] = useState([])
    const [userProfile, setUserProfile] = useState(null)

    async function getUserMaps() {
        setIsLoadingMaps(true)
        const zipmapRepository = new ZipmapRepository()
        const userMapsResponse = await zipmapRepository.getUserMaps()
        console.log(userMapsResponse)
        setUserMaps(userMapsResponse.maps.map((map) => {
            return {
                ...map,
                role: userMapsResponse.mapIdToUserRole[map.id]
            }
        }))
        if (userMapsResponse.maps.length > 0) {
            setSelectedMap(userMapsResponse.maps[0])
        }
        setIsLoadingMaps(false)
    }

    useEffect(() => {
        async function getUserLoginStatus() {
            const {
                data: { user },
            } = await supabase.auth.getUser()
            if (user != null) {
                console.log(`user object is ${JSON.stringify(user)}`)
                const userRepository = new UserRepository()
                const userProfileResponse = await userRepository.getUserProfile()
                console.log(userProfileResponse)
                setUserProfile(userProfileResponse.user)
            } else {
                navigate("/login", {replace: true})
            }
        }

        async function getUserInvitations() {
            const userRepository = new UserRepository()
            const userInvitationsResponse = await userRepository.getUserPendingInvitations()
            console.log(userInvitationsResponse)
            setUserInvitations(userInvitationsResponse.invitations.map((invitation) => {
                return {
                    ...invitation,
                    mapTitle: userInvitationsResponse.mapIdToName[invitation.mapId]
                }
            }))
        }

        Promise.all(
            [
                getUserLoginStatus(),
                getUserMaps(),
                getUserInvitations()
            ]
        )

    }, [])


    async function onSignOutClick() {
        const { error } = await supabase.auth.signOut(
            {
                scope: "local"
            }
        )
        console.log(`sign out error is ${JSON.stringify(error)}`)
        navigate("/login", { replace: true })
    }

    function onMapUpdated(updatedMap) {
        console.log(`onMapUpdated: ${JSON.stringify(updatedMap)}`)
        setUserMaps(
            userMaps.map((userMap) => {
                if (userMap.id == updatedMap.id) {
                    return updatedMap
                }
                return userMap
            })
        )
        setSelectedMap(updatedMap)
    }

    function onAddMapClick() {
        setIsAddMapModalOpen(true)
    }

    function onMapAdded(map) {
        setUserMaps([...userMaps, map])
        setSelectedMap(map)
        setIsAddMapModalOpen(false)
    }

    function onMapSelected(map) {
        setSelectedMap(map)
    }

    function onMapDeleted() {
        const updatedMapList = userMaps.filter((userMap) => userMap.id !== selectedMap.id)
        setUserMaps(updatedMapList)
        if (userMaps.length > 0) {
            setSelectedMap(updatedMapList[0])
        } else {
            setSelectedMap(null)
        }
    }

    async function acceptInvitation(invitation) {
        setIsSavingInvitation(true)
        const userRepository = new UserRepository()
        await userRepository.acceptInvitation(invitation.id)
        setUserInvitations(userInvitations.filter((userInvitation) => userInvitation.id !== invitation.id))
        setIsSavingInvitation(false)
        getUserMaps()
    }

    async function declineInvitation(invitation) {
        setIsSavingInvitation(true)
        const userRepository = new UserRepository()
        await userRepository.declineInvitation(invitation.id)
        setUserInvitations(userInvitations.filter((userInvitation) => userInvitation.id !== invitation.id))
        setIsSavingInvitation(false)
    }

    function onDismissInvitationClick(invitation) {
        console.log(invitation)
        declineInvitation(invitation)
    }

    function onAcceptInvitationClick(invitation) {
        console.log(invitation)
        acceptInvitation(invitation)
    }

    function onDeclineInvitationClick(invitation) {
        console.log(invitation)
        declineInvitation(invitation)
    }

    return (
        <div className="drawer h-full flex flex-row bg-base-200 lg:drawer-open">
            <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
            <Helmet><title>Dashboard | zipmap.io</title></Helmet>
            <DashboardSideNav isLoading={isLoadingMaps} userMaps={userMaps} userProfile={userProfile} analytics={analytics} onSignOutClick={onSignOutClick} selectedMapId={selectedMap?.id} onMapSelected={(map) => onMapSelected(map)}onAddMapClick={onAddMapClick} />
            <div className="flex flex-col flex-1 max-w-full drawer-content">
            {
                userInvitations.length > 0 && <div className="w-full shrink-0">
                    <PendingInvitations 
                    isSaving={isSavingInvitation}
                    pendingInvitations={userInvitations} 
                    onDismissInvitationClick={onDismissInvitationClick} 
                    onAcceptInvitationClick={onAcceptInvitationClick} 
                    onDeclineInvitationClick={onDeclineInvitationClick} />
                </div>
            }
            
            {
                selectedMap && <DashboardPageMain 
                analytics={analytics} 
                viewingMap={selectedMap}
                onMapUpdated={(map) => onMapUpdated(map)}
                onMapDeleted={() => onMapDeleted()}
                userInvitations={userInvitations}
                 />
            }
            {
                !isLoadingMaps && userMaps.length == 0 && <div className="h-full flex-1 relative flex flex-col items-center pt-16">
                    <div className="w-full text-center">
                    Hello {userProfile?.name} 👋🏼! You do not have a map yet. 
                    </div>
                    <div className="w-full text-center">
                    Create one or have someone invite you to an existing map. 
                    </div>
                </div>
            }
            </div>
            {
                isAddMapModalOpen && <DashboardAddMapModal
                isAddMapModalOpen={isAddMapModalOpen}
                onAddMapModalDismiss={() => { setIsAddMapModalOpen(false) }}
                onMapAdded={(map) => onMapAdded(map)}
                />
            }
        </div>
    )
}
